// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--LZE0a";
export var nav = "Footer-module--nav---OSZq";
export var nav_wrapper = "Footer-module--nav_wrapper--iwnzX";
export var nav_title = "Footer-module--nav_title--wSe+w";
export var nav_item = "Footer-module--nav_item--IHVpE";
export var nav_link = "Footer-module--nav_link--YhqJy";
export var nav_content = "Footer-module--nav_content--aJHlp";
export var info_content = "Footer-module--info_content--lEGnd";
export var text = "Footer-module--text--lBRtT";